import { ThemeColorVariable as e } from "../../theme/theme-types.js";
const c = "label:not([data-checked]):not([data-disabled]):hover", a = "label[data-checked]:not([data-disabled]):hover", r = "label[data-disabled]:not([data-checked]):hover", t = "label[data-disabled][data-checked]:hover", d = {
  // Target only device that supports hover (excludes thouch screen devices):
  "@media(hover: hover)": {
    // General hover styles for entire switch:
    [c]: {
      ".chakra-switch__track": {
        borderColor: e.OnSurface
      },
      ".chakra-switch__thumb": {
        bg: e.OnSurface
      }
    },
    [a]: {
      ".chakra-switch__track": {
        bg: e.AccentHover,
        borderColor: e.AccentHover
      },
      ".chakra-switch__thumb": {
        bg: e.OnAccent
      }
    },
    [r]: {
      ".chakra-switch__track": {
        bg: e.Surface,
        borderColor: e.OnSurfaceSubdued
      },
      ".chakra-switch__thumb": {
        bg: e.OnSurfaceSubdued
      }
    },
    [t]: {
      ".chakra-switch__track": {
        bg: e.Accent,
        borderColor: e.Accent
      },
      ".chakra-switch__thumb": {
        bg: e.OnAccent
      }
    }
  }
};
export {
  d as hoverStyles
};
